import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Form, Input, Spin, Typography, message } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { schoolAdministrationAPI as api } from '../../services/api';

export default function SchoolAdministratorActivation() {
  const location = useLocation(), navigate = useNavigate(), { user, isAuthenticated, setUserLogin, logout } = useAuth();
  const token = new URLSearchParams(location.hash.slice(1)).get('token');
  const [info,setInfo] = useState(null), [error,setError] = useState(''), [loading,setLoading] = useState(true), [saving,setSaving] = useState(false), [done,setDone] = useState(false);
  useEffect(() => {
    let active = true;
    if (!token) { setLoading(false); setError('邀请无效，请使用完整的激活链接'); return; }
    setDone(false); setInfo(null); setError(''); setLoading(true);
    api.preview(token || '').then(res => { if (active) setInfo(res.data.data); }).catch(e => { if (active) setError(e.response?.data?.message || '邀请无法读取'); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  },[token]);
  const activate = async values => {
    setSaving(true);
    try {
      const payload = { token, code: values.code };
      if (values.username) payload.username = values.username;
      if (values.password) payload.password = values.password;
      await api.activate(payload); setDone(true); message.success('学校管理员授权已激活');
      navigate(location.pathname,{ replace: true });
      if (info.kind === 'new') logout();
      else if (isAuthenticated) {
        try {
        const res = await fetch('/api/v2/auth/me',{ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
        const payload = await res.json();
        if (payload.success) setUserLogin(payload.data?.user || payload.data, localStorage.getItem('token'));
        } catch { message.info('授权已激活，重新登录即可进入学校工作台'); }
      }
    } catch(e) { if (e.response?.status === 401) { logout(); message.info('登录已失效，请登录原账号后领取'); } else message.error(e.response?.data?.message || '激活失败'); }
    finally { setSaving(false); }
  };
  return <div style={{ maxWidth: 560, margin: '48px auto', padding: '0 16px' }}><Card title="学校管理员本人激活"><Spin spinning={loading}>
    {done ? <Alert type="success" showIcon message="激活完成" description={<Button type="primary" onClick={() => { window.location.href = isAuthenticated ? '/school-admin' : '/login'; }}>{isAuthenticated ? '进入学校工作台' : '使用刚设置的账号登录'}</Button>} />
      : error ? <Alert type="error" showIcon message={error} /> : info && <>
        <Typography.Title level={4}>{info.schoolName}</Typography.Title><p>邀请有效至：{new Date(info.expiresAt).toLocaleString()}</p>
        {info.kind === 'existing' && !isAuthenticated ? <Alert type="info" showIcon message="请先使用被邀请教师的原账号登录" description={<Button type="primary" onClick={() => navigate('/login',{ state: { returnTo: `${location.pathname}${location.hash}` } })}>登录原账号后领取</Button>} /> :
          <Form layout="vertical" onFinish={activate} initialValues={{ username: info.kind === 'existing' ? user?.username || '' : '' }}>
            <Alert showIcon type="info" message={info.kind === 'existing' ? '已有用户名和密码可留空；只有微信登录的账号需补设后台登录信息。原教师身份和班级保留。' : '请输入通过已核实渠道收到的交接核验码，并由本人设置登录信息。'} style={{ marginBottom: 20 }} />
            <Form.Item name="code" label="交接核验码" rules={[{ required: true },{ pattern: /^\d{6}$/, message: '请输入6位核验码' }]}><Input autoComplete="one-time-code" maxLength={6} /></Form.Item>
            <Form.Item name="username" label="后台登录用户名" rules={info.kind === 'new' ? [{ required: true },{ min: 3 }] : []}><Input autoComplete="username" /></Form.Item>
            <Form.Item name="password" label="本人设置的登录密码" rules={[...(info.kind === 'new' ? [{ required: true }] : []),{ min: 8, message: '密码至少8位' }]}><Input.Password autoComplete="new-password" /></Form.Item>
            <Button type="primary" htmlType="submit" loading={saving}>确认领取学校管理员授权</Button>
          </Form>}
      </>}
  </Spin></Card></div>;
}
